<template>
    <div class="row">
        <div class="col-12">
            <div class="ibox form">
                <div class="ibox-title ibox-grey">
                    <h4>{{ __('analyze_summary_sell_and_buy') }}</h4>
                    <div class="ibox-tools">
                        <button-open-help-modal :in-extra-div="false" :helpName="'ASC-001'"/>
                    </div>
                </div>

                <div class="ibox-content">
                    <div class="row bg-light">
                        <div class="col">
                        {{__('sell_documents_count')}}
                            <div>
                                <label>
                                    <input type="radio" :value="'1'" v-model="summaryConfig.include_sell_document_count" :disabled="mode == 'desktop'"/>
                                    {{ __('yes') }}
                                </label>
                            </div>
                            <div v-if="mode != 'desktop'">
                                <label>
                                    <input type="radio" :value="'0'" v-model="summaryConfig.include_sell_document_count"/>
                                    {{ __('no_upper') }}
                                </label>
                            </div>
                        </div>

                        <div class="col">
                            {{__('sell_value_in_base_currency')}}
                            <div>
                                <label>
                                    <input type="checkbox" v-model="summaryConfig.sell_value_in_base_currency_net" @change="handleSellValueChange('net')" :disabled="mode == 'desktop'"/>
                                    {{ __('net') }}
                                </label>
                            </div>
                            <div v-if="mode != 'desktop'" >
                                <label>
                                    <input type="checkbox" v-model="summaryConfig.sell_value_in_base_currency_gross" @change="handleSellValueChange('gross')"/>
                                    {{ __('gross') }}
                                </label>
                            </div>
                        </div>

                        <div class="col">
                            {{__('buy_value_in_base_currency')}}
                            <div>
                                <label>
                                    <input type="checkbox" v-model="summaryConfig.buy_value_in_base_currency_net" @change="handleBuyValueChange('net')" :disabled="mode == 'desktop'"/>
                                    {{ __('net') }}
                                </label>
                            </div>
                            <div v-if="mode != 'desktop'">
                                <label>
                                    <input type="checkbox" v-model="summaryConfig.buy_value_in_base_currency_net_and_vat" @change="handleBuyValueChange('net-and-vat')" :disabled="mode == 'desktop'"/>
                                    {{ __('net_and_vat') }}
                                </label>
                            </div>
                            <div v-if="mode != 'desktop'">
                                <label>
                                    <input type="checkbox" v-model="summaryConfig.buy_value_in_base_currency_gross" @change="handleBuyValueChange('gross')"/>
                                    {{ __('gross') }}
                                </label>
                            </div>
                        </div>
                        <div class="col">
                            {{__('values')}}
                            <div>
                                <label>
                                    <input type="radio" :value="'1'" v-model="summaryConfig.include_correction" :disabled="mode == 'desktop'"/>
                                    {{ __('with_include_correction') }}
                                </label>
                            </div>
                            <div v-if="mode != 'desktop'">
                                <label>
                                    <input type="radio" :value="'0'" v-model="summaryConfig.include_correction"/>
                                    {{ __('without_include_correction') }}
                                </label>
                            </div>
                        </div>

                        <div class="col">
                            {{__('period')}}
                            <div>
                                <label>
                                    <input type="radio" :value="'12'" v-model="summaryConfig.period" :disabled="mode == 'desktop'"/>
                                    {{ __('12_months') }}
                                </label>
                            </div>
                            <div v-if="mode != 'desktop'">
                                <label>
                                    <input type="radio" :value="'24'" v-model="summaryConfig.period"/>
                                    {{ __('24_months') }}
                                </label>
                            </div>
                        </div>
                    </div>
                    <summary-chart :config="summaryConfig"
                                   :buySummary="buySummary"
                                   :sellSummary="sellSummary"
                                   :mode="mode">

                    </summary-chart>

                    </div>
                </div>
            </div>
        </div>
</template>

<script>
import SummaryChart from "./SummaryChart";
export default {
    name: "SummaryAnalyzeBox",
    components: {SummaryChart},
    props:{
        summaryConfig:{
            type:Object,
        },
        buySummary:{
            type:Object,
        },
        sellSummary:{
            type:Object
        },
        mode:{
            type:String,
            default:"standard"
        }
    },
    methods: {
        handleSellValueChange(type) {
            if (type === 'net') {
                this.summaryConfig.sell_value_in_base_currency_gross = false;
            } else if (type === 'gross') {
                this.summaryConfig.sell_value_in_base_currency_net = false;
            }
        },
        handleBuyValueChange(type) {
            if (type === 'net') {
                this.summaryConfig.buy_value_in_base_currency_gross = false;
                this.summaryConfig.buy_value_in_base_currency_net_and_vat = false;
            } else if (type === 'gross') {
                this.summaryConfig.buy_value_in_base_currency_net = false;
                this.summaryConfig.buy_value_in_base_currency_net_and_vat = false;
            }
            else if(type === 'net-and-vat'){
                this.summaryConfig.buy_value_in_base_currency_gross = false;
                this.summaryConfig.buy_value_in_base_currency_net = false;
            }
        }
    }
}
</script>

<style scoped>

</style>
